import { render, staticRenderFns } from "./ProductShapes.vue?vue&type=template&id=2d559d4e&"
import script from "./ProductShapes.vue?vue&type=script&lang=js&"
export * from "./ProductShapes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports